import { useParams } from 'react-router-dom'

interface Params {
  warehouseId?: string
  equipmentId?: string
  categoryId?: string
  cartId?: string
}

const useShopParams = () => {
  return useParams<Params>()
}

export default useShopParams